import AbstractLazyLoad from '../../../commons/js/components/lazy-load/AbstractLazyLoad';

export default function () {
	new OurCustomersCarouselLoader().initialize();
}

class OurCustomersCarouselLoader extends AbstractLazyLoad {

	constructor() {
		super('.l-our-customers__glide');
	}

	protected load(): void {
		import('@glidejs/glide').then(({ default: Glide }) => {
			new Glide('.l-our-customers__glide', {
				perView: 1,
				rewind: false,
				focusAt: 'center',
				breakpoints: {
					600: { perView: 1 },
  				1000: { perView: 2 }
				}
			}).mount();
		});
	}
}